import {BaseButton} from "components"
import {useHistory, useLocation} from "react-router-dom"
import {useSearchParam} from "hooks"
import {findIndex, get, head, last, size} from "lodash"
import cx from "classnames"
import styles from "./TaskSubmission.module.css"

export const CustomDigitalActions = ({taskId, className = ""}) => {
    const history = useHistory()
    const location = useLocation()

    const {value: relatedTaskIds} = useSearchParam("relatedTaskIds", {
        parse: (value) => value.split(",").map((item) => +item)
    })
    const backUrl = get(location, "state.backUrl")

    const getBackRelatedTaskId = () => {
        const idx = findIndex(relatedTaskIds, (item) => item === taskId)
        if (idx > 0) {
            return relatedTaskIds[idx - 1]
        }
        return last(relatedTaskIds)
    }

    const getNextRelatedTaskId = () => {
        const idx = findIndex(relatedTaskIds, (item) => item === taskId)
        if (idx < size(relatedTaskIds) - 1) {
            return relatedTaskIds[idx + 1]
        }
        return head(relatedTaskIds)
    }

    return (
        <div className={cx(styles.customDDActions, className)}>
            <BaseButton
                title="Go Back Task"
                variant="secondary"
                onClick={() => {
                    history.push({
                        pathname: `/tasks/submissions`,
                        search: `id=${getBackRelatedTaskId()}&type=customDD&relatedTaskIds=${relatedTaskIds}`,
                        state: {backUrl}
                    })
                }}
            />
            <BaseButton
                title="Go Next Task"
                variant="secondary"
                onClick={() => {
                    history.push({
                        pathname: `/tasks/submissions`,
                        search: `id=${getNextRelatedTaskId()}&type=customDD&relatedTaskIds=${relatedTaskIds}`,
                        state: {backUrl}
                    })
                }}
            />
        </div>
    )
}
